export const NAMESPACE = 'onboarding'